export default [
  {
    path: '/admin/document-categories',
    name: 'indexDocumentCategoriesAdmin',
    meta: { title: 'indexDocumentCategoriesAdmin' },
    component: () => import('@/pages/admin/document-categories'),
  },
  {
    path: "/admin/document-categories/create",
    name: "createDocumentCategoriesAdmin",
    meta: { title: 'createDocumentCategoriesAdmin' },
    component: () => import('@/pages/admin/document-categories/create'),
  },
  {
    path: "/admin/document-categories/:id/edit",
    name: "editDocumentCategoriesAdmin",
    meta: { title: 'editDocumentCategoriesAdmin' },
    component: () => import('@/pages/admin/document-categories/edit'),
  },
]
